// src/components/bsm/EnrollmentModal.js
import React, { useEffect, useRef } from 'react';
import { CloseIcon, WhatsAppIcon, MailIcon, CheckIcon } from './BsmIcons';

export default function EnrollmentModal({
  isOpen,
  onClose,
  enrollForm,
  setEnrollForm,
  handleWhatsAppEnroll,
  handleEmailEnroll,
  formSentMethod,
}) {
  const nameInputRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const timer = setTimeout(() => {
      if (nameInputRef.current) {
        nameInputRef.current.focus();
      }
    }, 50);

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = originalOverflow;
      clearTimeout(timer);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="enrollment-modal-title">
      <div className="modal-content-card" onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div>
            <h3 id="enrollment-modal-title">Apply for Batch Admission</h3>
            <p>Direct enrollment desk • Brilliant Share Market Academy Pune</p>
          </div>
          <button
            type="button"
            className="btn-modal-close"
            onClick={onClose}
            aria-label="Close modal"
          >
            <CloseIcon width={16} height={16} />
          </button>
        </div>

        <div className="modal-body">
          <div className="modal-input-group">
            <label htmlFor="modal-name">Full Name *</label>
            <input
              ref={nameInputRef}
              id="modal-name"
              type="text"
              placeholder="e.g. Rahul Sharma"
              value={enrollForm.name}
              onChange={(e) => setEnrollForm((prev) => ({ ...prev, name: e.target.value }))}
            />
          </div>

          <div className="modal-input-row">
            <div className="modal-input-group">
              <label htmlFor="modal-phone">WhatsApp Number *</label>
              <input
                id="modal-phone"
                type="tel"
                placeholder="e.g. 98765 43210"
                value={enrollForm.phone}
                onChange={(e) => setEnrollForm((prev) => ({ ...prev, phone: e.target.value }))}
              />
            </div>
            <div className="modal-input-group">
              <label htmlFor="modal-email">Email Address</label>
              <input
                id="modal-email"
                type="email"
                placeholder="e.g. rahul@example.com"
                value={enrollForm.email}
                onChange={(e) => setEnrollForm((prev) => ({ ...prev, email: e.target.value }))}
              />
            </div>
          </div>

          <div className="modal-input-group">
            <label htmlFor="modal-course">Selected Program</label>
            <input
              id="modal-course"
              type="text"
              readOnly
              value={enrollForm.course}
              className="input-readonly"
            />
          </div>

          <div className="modal-input-group">
            <label htmlFor="modal-mode">Preferred Training Mode</label>
            <select
              id="modal-mode"
              value={enrollForm.preferredMode}
              onChange={(e) => setEnrollForm((prev) => ({ ...prev, preferredMode: e.target.value }))}
            >
              <option value="Classroom at Pune Center (Akurdi)">Offline Classroom at Pune Center (Akurdi)</option>
              <option value="Live Interactive Online (Zoom)">Live Interactive Online (Zoom)</option>
            </select>
          </div>

          <div className="modal-actions-box">
            <button
              type="button"
              className="btn-modal-whatsapp"
              onClick={handleWhatsAppEnroll}
            >
              <WhatsAppIcon width={16} height={16} />
              <span>Connect with Admissions Desk on WhatsApp</span>
            </button>
            <button
              type="button"
              className="btn-modal-gmail"
              onClick={() => handleEmailEnroll('gmail')}
            >
              <MailIcon width={15} height={15} />
              <span>Send via Gmail</span>
            </button>
          </div>

          {formSentMethod && (
            <div className="modal-success-alert">
              <CheckIcon width={14} height={14} />
              <span>Enquiry initiated! Our admissions coordinator will verify seat availability and contact you immediately.</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
